import { render } from "./WishlistTeaser.vue?vue&type=template&id=cd36f200"
import script from "./WishlistTeaser.vue?vue&type=script&lang=js"
export * from "./WishlistTeaser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Sources/JavaScript/Extensions/Components/WishlistTeaser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cd36f200"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cd36f200', __exports__)) {
    api.reload('cd36f200', __exports__)
  }
  
  module.hot.accept("./WishlistTeaser.vue?vue&type=template&id=cd36f200", () => {
    api.rerender('cd36f200', render)
  })

}


export default __exports__